<template>


  <div class="rounded border border-gray-300 py-3 px-5 bg-white dark:bg-[#1C2128] dark:text-gray-400 flex flex-col items-center dark:border-gray-500">
    <div>
      <p class="font-semibold">{{ uiName() }}</p>
    </div>
    <div class="pb-1 pt-2">
      <p class="font-bold text-[32px] text-blue-600">{{ dataSet.count }}</p>
    </div>
    <div class="text-gray-500 text-sm dark:text-gray-400 flex flex-col items-center">
      <p class="font-semibold">{{ dataSet.difference_with_previous_tenure }}</p>
      <p class> {{ I18N.website_content.analytics.vs_prior }} {{ dataSet.duration }} </p>
    </div>
  </div>
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"

export default {
  name: 'StatsCard',
  props: ['name', 'duration'],
  mixins: [RequestMixin, Constants],
  data() {
      return {
        dataSet: {
          count: '',
          difference_with_previous_tenure: '',
          duration: ''
        }
      };
  },
  methods: {
    uiName(){
      if(this.name === 'created_bookings') {
        return this.I18N.website_content.analytics.scheduled_bookings
      } else if (this.name === 'completed_bookings') {
        return this.I18N.website_content.analytics.completed_bookings
      } else if (this.name === 'rescheduled_bookings') {
        return this.I18N.website_content.analytics.rescheduled_bookings
      } else if (this.name === 'canceled_bookings') {
        return this.I18N.website_content.analytics.canceled_bookings
      } else if (this.name === 'total_users') {
        return this.I18N.website_content.analytics.visitors
      } else if (this.name === 'new_users') {
        return this.I18N.website_content.analytics.new_visitors
      } else if (this.name === 'recurring_users') {
        return 'Recurring Visitors'
      }  else if (this.name === 'converted_users') {
        return 'Converted Visitors'
      }


    },

    async fetchStats() {
      let resp = await this.axiosRequest('GET',`/analytics/${this.name}?duration=${this.duration}`, {}, false)
      this.dataSet = resp.response.data
    }
  },
  created() {
    if(this.duration !== undefined) {
      this.fetchStats()
    }
  }
};
</script>
